// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SqWS","select":"styles_select__VGffb"};